import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { iecVoteOption } from '../../models/iec/iec-ballot-vote';
import { ciVoteOption } from '../../models/ci/ci-vote';
import { srsVoteOption } from '../../models/sr/srs-vote';
import { ViewVoteIconsConstants } from '../../../../../shared/constants/view-vote-icons-constants';
import { sdVoteOption } from '../../../../../shared/constants/sd-ballot.constants';



export interface Legend {
  name: string;
  type: string;
  icon: string;
  color: string;
}

@Component({
    selector: 'app-vote-legend',
    templateUrl: './vote-legend.component.html',
    styleUrl: './vote-legend.component.scss',
    standalone: false
})
export class VoteLegendComponent implements OnInit {
  @Input() ballotType: string = '';

  @ViewChild('popover') popover!: NgbPopover;

  public readonly ViewVoteIconsConstants = ViewVoteIconsConstants;


  legends: Legend[] = [
    { name: iecVoteOption["IN_FAVOUR_OF"].text, type: 'IEC', icon: iecVoteOption["IN_FAVOUR_OF"].icon, color: iecVoteOption["IN_FAVOUR_OF"].color },
    { name: iecVoteOption["AGAINST"].text, type: 'IEC', icon: iecVoteOption["AGAINST"].icon, color: iecVoteOption["AGAINST"].color },
    { name: iecVoteOption["ABSTAIN"].text, type: 'IEC', icon: iecVoteOption["ABSTAIN"].icon, color: iecVoteOption["ABSTAIN"].color },

    { name: ciVoteOption["Agree"].text, type: 'CIB', icon: ciVoteOption["Agree"].icon, color: ciVoteOption["Agree"].color },
    { name: ciVoteOption["Disagree"].text, type: 'CIB', icon: ciVoteOption["Disagree"].icon, color: ciVoteOption["Disagree"].color },

    { name: srsVoteOption["SVT_RECONFIRM"].text, type: 'SRS', icon: srsVoteOption["SVT_RECONFIRM"].icon, color: srsVoteOption["SVT_RECONFIRM"].color },
    { name: srsVoteOption["SVT_REVISE"].text, type: 'SRS', icon: srsVoteOption["SVT_REVISE"].icon, color: srsVoteOption["SVT_REVISE"].color },
    { name: srsVoteOption["SVT_WITHDRAW"].text, type: 'SRS', icon: srsVoteOption["SVT_WITHDRAW"].icon, color: srsVoteOption["SVT_WITHDRAW"].color },

    { name: sdVoteOption["VT_AGREE"].text, type: 'NPB', icon: sdVoteOption["VT_AGREE"].icon, color: sdVoteOption["VT_AGREE"].color },
    { name: sdVoteOption["VT_DISAGREE"].text, type: 'NPB', icon: sdVoteOption["VT_DISAGREE"].icon, color: sdVoteOption["VT_DISAGREE"].color },

  ];

  private allCommonLegends: Legend[] = [
    { name: 'No Response', type: 'common', icon: sdVoteOption["VT_NONE"].icon, color: 'text-orange-600'},
    { name: 'Comments', type: 'common', icon: this.ViewVoteIconsConstants.chatBubble.iconName, color: this.ViewVoteIconsConstants.chatBubble.colorClass },
    { name: 'Supporting Information', type: 'SRS', icon: this.ViewVoteIconsConstants.quickReference.iconName, color: this.ViewVoteIconsConstants.quickReference.colorClass },
    { name: 'Authorisation Document', type: 'common', icon: this.ViewVoteIconsConstants.draft.iconName, color: this.ViewVoteIconsConstants.draft.colorClass },
    { name: 'Proxy Vote', type: 'common', icon: this.ViewVoteIconsConstants.howToVote.iconName, color: this.ViewVoteIconsConstants.howToVote.colorClass },
    { name: 'History', type: 'common', icon: this.ViewVoteIconsConstants.history.iconName, color: this.ViewVoteIconsConstants.history.colorClass }]

  legendsByBallotType: Legend[] = [];
  commonLegends: Legend[] = [];

  ngOnInit(): void {
    this.legendsByBallotType = this.legends.filter(l => l.type == this.ballotType);
    this.commonLegends = this.allCommonLegends.filter(l => l.type == this.ballotType || l.type == 'common');
  }


  closeLegendPopover() {
    if (this.popover.isOpen()) this.popover.close();
  }
}
